/**
 * Created by lu on 2018/5/24.
 */
var nb = require('../../nb');
var key;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        msgList: require('./MsgList')
    },
    method: {
        init: function () {
            var self = this;


            this.onChange('count', function (inEvent, inCount) {
                var count = inCount || 0;
                if (count > 0) {
                    this.set('hasMsg', true);
                    this.set('inState', 'has-info');
                } else {
                    this.set('hasMsg', '');
                }
                this.set('countText', '[' + count + ']');

            }, this);


            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                key = inData;

                if (key == 'cn') {

                    self.setOpts({
                        MsgText: '消息：',
                        NewMsgText: '最新消息',
                        AllMsgText: '查看全部消息 >>'
                    });
                } else if (key == 'en') {

                    self.setOpts({
                        MsgText: 'Message：',
                        NewMsgText: 'New Message',
                        AllMsgText: 'All Message >>'
                    });
                }
            })
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/notice/MsgWrap.js
// module id = 26
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34